import cn from 'classnames'
import { IPartnerStatusLabel } from 'legacy/lut/features/partner360/configuration/models/IPartnerStatus'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { DEFAULT_COLOR } from './configs'

import styles from './PartnerStatusLabel.module.scss'

interface IPartnerStatusLabelProps {
  profile: IPartnerStatusLabel
  className?: string
}

export const PartnerStatusLabel: FC<IPartnerStatusLabelProps> = ({ profile, className }) => {
  return (
    <Tooltip tipContent={() => <Translation text={profile.Info} span />}>
      <div
        className={cn(styles.profile, className)}
        style={{ backgroundColor: profile.Color || DEFAULT_COLOR }}
      >
        {profile.Title}
      </div>
    </Tooltip>
  )
}
